import { Component, ElementRef, OnInit, ViewChild, AfterViewInit } from '@angular/core'
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser'
import { FileProf } from 'src/api/invoice-leaf/invoice-leaf-api.interface'
import { InvoiceLeafApiService } from 'src/api/invoice-leaf/invoice-leaf-api.service'
import { FileManagementService } from 'src/app/common/file-management.service'
import { SelectOption } from 'src/app/module/common-parts/select/select.component.interface'
import { InvoiceLeafService } from '../invoice-leaf.service'
import { InvoiceService } from 'src/api/invoice-api/invoice-api.service'
import { AuthService } from 'src/app/components/isbeauth/auth.service'
import { sortedItems } from 'src/app/common/common'
import { ImportantNoticePopupComponent } from 'src/app/module/common-parts/important-notice-popup/important-notice-popup.component'
import { NavService } from 'src/app/components/nav/nav.service'
import { Subscription } from 'rxjs'

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss']
})
export class InvoiceComponent implements OnInit, AfterViewInit {
  title = '請求書確認'
  loading = true
  sending = false
  fileUrl: SafeResourceUrl = null
  selectedFilePath = ''
  periodIndexList: FileProf[] = []
  periods: SelectOption[] = []
  actuateOptions: SelectOption[] = []
  selectedActuateCd = ''
  scroll = 0
  isInvoiceTargetCustomer = false
  public viewCd = 'myidea-invoice'
  subscription: Subscription
  @ViewChild('scrollableContent', { static: false }) scrollableContent: ElementRef
  @ViewChild('noticePopup') noticePopupComponent: ImportantNoticePopupComponent

  constructor(
    private domSanitizer: DomSanitizer,
    private invoiceLeafApiService: InvoiceLeafApiService,
    private invoiceLeafService: InvoiceLeafService,
    private fileManagementService: FileManagementService,
    private invoiceService: InvoiceService,
    private authService: AuthService,
    private navService: NavService
  ) {}

  ngOnInit(): void {
    // TBSNo.	485 お知らせの提示改善対応
    const s = this
    s.subscription = s.navService.importantNoticeInfoSource$.subscribe((data) => {
      // 通知データを更新してから重要なお知らせ表示チェック
      this.checkImportantNotice()
    })
    this.checkImportantNotice()
    this.getActuates()
  }

  enableInvoice2025Notice = false
  showNoticePopupComponent = false
  // 重要なお知らせポップアップ表示チェック
  checkImportantNotice(): void {
    this.enableInvoice2025Notice = false
    const notificationData = this.navService.getImportantNoticeAction
    if (notificationData?.actionTransactionKey === '{viewCd}-clickPetabo-invoice2025') {
      this.enableInvoice2025Notice = true
      this.ngAfterViewInit()
    }
  }

  // TBSNo.	485 お知らせの提示改善対応
  showDontShowAgainKey = 'invoice-notice-202508-dont-show_3'
  ngAfterViewInit(): void {
    // ViewChildが初期化された後に実行
    setTimeout(() => {
      this.checkImportantNotice()
      if (this.noticePopupComponent && this.enableInvoice2025Notice && !this.showNoticePopupComponent) {
        this.showNoticePopupComponent = true
        this.noticePopupComponent.show()
      }
    }, 0)
  }

  // 請求先稼働取得
  async getActuates(): Promise<void> {
    this.actuateOptions = await this.invoiceLeafService.getActuateOptions()
    this.selectActuate(this.actuateOptions[0].value)

    // 自身が請求先となっているマスタを取得
    const invoiceTargetsRet = await this.invoiceService.GetInvoiceTargetsByCutomer(
      this.authService.AccountInfo.customerCd
    )
    if (invoiceTargetsRet?.resultCode !== 0) {
      return
    }
    this.isInvoiceTargetCustomer = invoiceTargetsRet.data.length > 0
  }

  // 期間取得
  async getPeriods(): Promise<void> {
    if (!this.selectedActuateCd) {
      return
    }
    this.loading = true
    const ret = await this.invoiceLeafApiService.GetInvoiceIndex(this.selectedActuateCd)
    this.loading = false
    if (ret?.resultCode !== 0 && !ret?.data.length) {
      return
    }
    this.periodIndexList = ret.data
    this.periods = []
    ret.data.forEach((date) => {
      const selectOption: SelectOption = {
        label: `${date.year}年${date.month}月`,
        value: date.fullPath
      }
      this.periods.push(selectOption)
    })
    this.periods = sortedItems(this.periods, 'value', false)
    if (this.periods.length) {
      this.selectPeriod(this.periods[0].value)
    }
  }
  // 稼働選択
  selectActuate(actuateCd: string): void {
    this.selectedFilePath = null
    this.fileUrl = null
    this.selectedActuateCd = actuateCd
    this.getPeriods()
  }

  // 期間選択
  async selectPeriod(fullPath: string): Promise<void> {
    if (!fullPath) {
      return
    }
    //this.scrollPeriod(fullPath)
    this.selectedFilePath = fullPath
    const url = this.invoiceLeafApiService.InvoiceFileUrl(this.selectedTarget)
    this.fileUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url)
  }

  get selectedTarget(): FileProf {
    return this.periodIndexList.find((x) => x.fullPath === this.selectedFilePath)
  }

  scrollPeriod(fullPath: string): void {
    if (!this.scrollableContent) {
      setTimeout(() => {
        this.scrollPeriod(fullPath)
      }, 500)
      return
    }
    const itemRow = 65
    const index = this.periods.findIndex((x) => x.value === fullPath)
    const targetPoint = index * itemRow
    const viewWidth = this.scrollableContent.nativeElement.clientWidth
    if (targetPoint >= this.scroll + viewWidth) {
      this.scrollableContent.nativeElement.scrollTo(targetPoint - itemRow * 2, 0)
      this.scroll = targetPoint - itemRow * 2
    } else if (targetPoint <= this.scroll) {
      this.scrollableContent.nativeElement.scrollTo(targetPoint - itemRow, 0)
      this.scroll = targetPoint - itemRow
    }
  }

  download(): void {
    const target = this.periodIndexList.find((x) => x.fullPath === this.selectedFilePath)
    this.fileManagementService.downloadPdfFile(
      this.invoiceLeafApiService.InvoiceFileUrl(this.selectedTarget),
      target.fileName
    )
  }
}
